import { useContext } from 'use-context-selector';
import { BlogLandingContext } from 'components/blogLandingProvider/BlogLandingProvider';
import { ContentSectionComponent } from 'components/contentSectionComponent/ContentSectionComponent';

export const BlogLandingContent = () => {
  const blogLandingContext = useContext(BlogLandingContext);

  if (blogLandingContext === undefined) {
    throw new Error(
      'BlogLandingContent must be used within a BlogLandingContext'
    );
  }

  const { articlesListing = [] } = blogLandingContext;

  return (
    <>
      {articlesListing.map((section, index) => {
        return (
          <div
            key={`${section?.__typename}-${index}`}
            className="content-section"
          >
            <ContentSectionComponent section={section} />
          </div>
        );
      })}
    </>
  );
};
